import { createContext } from 'react';

/**
 * What navigation components need from the signed-in shell: the session's permissions and the
 * live counts. Provided by the app shell; absent in the design gallery, where the components show
 * their design sample values.
 */
export interface LiveNav {
  permissions: string[];
  counts: { cases_open?: number; alerts_open?: number; alerts_critical?: number; approvals_pending?: number; whats_new_unread?: number };
}
export const LiveNavCtx = createContext<LiveNav | null>(null);
